if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();

        this.realButton = document.getElementById(this.dataset.targetButton);
        this.form = document.getElementById(this.dataset.targetForm);
        this.button = this.querySelector('.product-sticky-atc__button');
        this.buttonText = this.button ? this.button.querySelector('span') : null;

        if (!this.realButton || !this.form || !this.button) return;

        this.button.addEventListener('click', this.onClick.bind(this));

        this.syncButtonState();
        this.stateObserver = new MutationObserver(this.syncButtonState.bind(this));
        this.stateObserver.observe(this.realButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });

        this.visibilityObserver = new IntersectionObserver(this.onVisibilityChange.bind(this), {
          rootMargin: '0px 0px -10% 0px',
        });
        this.visibilityObserver.observe(this.realButton);
      }

      onVisibilityChange(entries) {
        const isRealButtonVisible = entries[entries.length - 1].isIntersecting;
        this.classList.toggle('product-sticky-atc--visible', !isRealButtonVisible);
        this.toggleAttribute('hidden', isRealButtonVisible);
      }

      syncButtonState() {
        const isDisabled = this.realButton.hasAttribute('disabled') || this.realButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = isDisabled;
        this.button.classList.toggle('loading', this.realButton.classList.contains('loading'));

        const realText = this.realButton.querySelector('span');
        if (realText && this.buttonText && realText.textContent.trim()) {
          this.buttonText.textContent = realText.textContent.trim();
        }
      }

      onClick() {
        if (this.button.disabled) return;
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.realButton.click();
        }
      }
    }
  );
}
